import { CARD_FILTERS_SLUGS_CARD_REQUIRED, type CardFilterType } from '@/defs/cardFilters'
import {
  GALLERY_GROUPBY_SLUGS_CARD_REQUIRED,
  GALLERY_SORTBY_SLUGS_CARD_REQUIRED,
  type GalleryGroupbySlugType,
  type GallerySortbySlugType,
} from '@/defs/gallery'

type Props = {
  cardFilters?: CardFilterType[]
  groupby: GalleryGroupbySlugType
  sortby: GallerySortbySlugType
}

export const isGalleryCardRequired = ({ cardFilters, groupby, sortby }: Props): boolean =>
  !!(
    GALLERY_GROUPBY_SLUGS_CARD_REQUIRED.includes(groupby) ||
    GALLERY_SORTBY_SLUGS_CARD_REQUIRED.includes(sortby) ||
    cardFilters?.some((c) => CARD_FILTERS_SLUGS_CARD_REQUIRED.includes(c.slug))
  )
